<footer>
  <div class="row">
    <div class="col-4 justify-content-start">v{{version}}</div>
    <div class="col-8 justify-content-end text-right">
      {{ now | date: "dd/MM/yyyy HH:mm:ss" }}
    </div>
  </div>
</footer>
